import { render, staticRenderFns } from "./OrderExportStateChip.vue?vue&type=template&id=00e06451&scoped=true"
import script from "./OrderExportStateChip.vue?vue&type=script&lang=ts"
export * from "./OrderExportStateChip.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e06451",
  null
  
)

export default component.exports